import type { FieldPolicy, TypePolicies } from '@apollo/client';

const teamIdReadPolicy: FieldPolicy['read'] = (teamId) => {
  return teamId ? teamId.replace('TEAMID-', '') : teamId;
};

const userIdReadPolicy: FieldPolicy['read'] = (userId) => {
  return userId ? userId.replace('UID-', '') : userId;
};

export const InteractionContactAgent: TypePolicies['InteractionContactAgent'] =
  {
    fields: {
      teamId: {
        read: teamIdReadPolicy,
      },
      userId: {
        read: userIdReadPolicy,
      },
    },
  };

export const InteractionContactOther: TypePolicies['InteractionContactOther'] =
  {
    fields: {
      teamId: {
        read: teamIdReadPolicy,
      },
      userId: {
        read: userIdReadPolicy,
      },
    },
  };

export const ContactResponse: TypePolicies['ContactResponse'] = {
  fields: {
    teamId: {
      read: teamIdReadPolicy,
    },
    userId: {
      read: userIdReadPolicy,
    },
  },
};
